export default "__VITE_ASSET__DmJhA3Zb__"